import { StateUtils } from 'utils';

const ADMIN_CLAIM = 'AdminClaim';
const tag = StateUtils.actionType(ADMIN_CLAIM);

export const BEFORE_PROCESSING = tag`BEFORE_PROCESSING`;
export const ON_FETCH_ADMINS = tag`ON_FETCH_ADMINS`;
export const ON_PUSH_ADMIN = tag`ON_PUSH_ADMIN`;
export const ON_DELETE_ADMIN = tag`ON_DELETE_ADMIN`;
export const ERROR_FETCH_ADMINS = tag`ERROR_FETCH_ADMINS`;
export const ERROR_INSERT_ADMINS = tag`ERROR_INSERT_ADMINS`;
export const ERROR_DELETE_ADMINS = tag`ERROR_DELETE_ADMINS`;
